import { motion } from "framer-motion";
import { Handshake, ShoppingBag, Truck, Wrench, LayoutGrid } from "lucide-react";
import { SERVICES } from "@/data/site";
import { EASE, SectionHead } from "@/components/motion/Reveal";
import { cn } from "@/lib/utils";

const ICONS = [Handshake, ShoppingBag, Truck, Wrench, LayoutGrid];

const Tile = ({ s, i }) => {
  const Icon = ICONS[i];
  const big = i === 0;
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: EASE, delay: i * 0.08 }}
      className={cn("group relative overflow-hidden rounded-[24px] border border-white/5 bg-ink-800 p-7 transition-[border-color] duration-500 hover:border-volt/40 sm:p-8", big ? "min-h-[420px] lg:col-span-6 lg:row-span-2" : "min-h-[240px] lg:col-span-3")}
      data-testid={`solution-tile-${i + 1}`}
    >
      {big && (
        <>
          <img src={s.img} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-50 transition-transform duration-[1.4s] group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/70 to-ink-950/10" />
        </>
      )}
      <div className="relative flex h-full flex-col">
        <div className="flex items-center justify-between">
          <span className="grid h-12 w-12 place-items-center rounded-2xl border border-white/10 bg-ink-950/60 backdrop-blur-md transition-[box-shadow,border-color] duration-500 group-hover:border-volt/50 group-hover:shadow-[0_0_30px_-6px_rgba(0,240,255,0.6)]">
            <Icon className="h-5 w-5 text-volt" />
          </span>
          <span className="font-mono text-xs text-slate-600">0{i + 1}</span>
        </div>
        <div className="mt-auto pt-10">
          <h3 className={cn("font-display font-semibold tracking-tight text-white", big ? "text-3xl sm:text-4xl" : "text-xl")}>{s.title}</h3>
          <p className={cn("mt-3 leading-relaxed text-slate-400", big ? "max-w-md text-base text-slate-300" : "text-sm")}>{s.desc}</p>
        </div>
      </div>
    </motion.div>
  );
};

export const TotalSolution = ({ index = "03" }) => (
  <section className="relative border-t border-white/5 bg-ink-900 py-28 lg:py-40" data-testid="total-solution-section">
    <div className="container-x">
      <SectionHead index={index} eyebrow="The Brewer Total Solution" title={["Everything you need.", "One local partner."]}>
        From the first conversation to the hundredth play, Brewer handles the equipment side of entertainment so you can run your business.
      </SectionHead>
      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:auto-rows-[240px] lg:grid-cols-12">
        {SERVICES.map((s, i) => (
          <Tile key={s.title} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
